import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { useDispatch, useSelector } from 'react-redux';
import api from './api';
import { sessionSlice } from './slices/auth/session.slice';
import { lobbyDetailsSlice } from './slices/lobby-details.slice';
import { achievementsSlice } from './slices/achievements.slice';
import { authModalSlice } from './slices/auth-modal.slice';
import { cookieConsentSlice } from './slices/cookie-consent.slice';
import { appInstallBannerSlice } from './slices/app-install-banner.slice';
import { newsfeedSlice } from '@/modules/probability-event/store/slices/newsfeed.slice';
import * as Sentry from '@sentry/react';

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
	attachReduxState: true,
});

const store = configureStore({
	reducer: {
		session: sessionSlice.reducer,
		lobbyDetails: lobbyDetailsSlice.reducer,
		achievements: achievementsSlice.reducer,
		authModal: authModalSlice.reducer,
		cookieConsent: cookieConsentSlice.reducer,
		appInstallBanner: appInstallBannerSlice.reducer,
		newsfeed: newsfeedSlice.reducer,
		[api.reducerPath]: api.reducer,
	},
	// Adding the api middleware enables caching, invalidation, polling,
	// and other useful features of `rtk-query`.
	middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware),
	enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(sentryReduxEnhancer),
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);
export default store;

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector = useSelector;
